import { ModelBase } from '../../core/model/model-base';

export class Bank extends ModelBase {
  constructor() {
    super();
  }

  clearingNumberFrom: number;
  clearingNumberTo: number;
  name: string;
}
